module.exports = __webpack_public_path__ + "img/linkedin.eba8c087.svg";